import { twMerge } from 'tailwind-merge'

type MenuProps = React.PropsWithChildren &
  React.HTMLAttributes<HTMLDivElement> & {
    selected: boolean
  }

export const Menu: React.FC<MenuProps> = ({ children, selected, className, ...props }) => (
  <div
    className={twMerge(
      'absolute right-0 z-10 mt-8 flex w-full origin-top flex-col rounded-md bg-white px-4 py-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none',
      selected
        ? 'scale-100 transform opacity-100 transition duration-300 ease-out'
        : 'pointer-events-none scale-95 transform opacity-0 transition duration-75 ease-in',
      className
    )}
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="menu-button"
    {...props}
  >
    {children}
  </div>
)
